<template>

<div class="control" v-tooltip="tooltip">

    <slot></slot>
    
</div>

</template>

<script>

export default {

    props: ['tooltip']

}

</script>

<style scoped>

.control {
}

</style>
